import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { Possessed } from '../../Possessed';
import {PossessedScatterSymbol} from '../../reels/PossessedScatterSymbol';
import {SimplePresentation} from './SimplePresentationRunner';


export class FreespinsScatterActivatePresentation extends SimplePresentation {

    constructor() {
        super("FreespinsScatterActivationPresentation");
    }

    public override shouldRun(): boolean {
        return Possessed.model.isFreespins() && Possessed.model.getScatterSymbols().length > 0;
    }


    buildTimeline(): void {
        const tl = this.tl;

        const scatters = <PossessedScatterSymbol[]>Possessed.reelView.getAllVisibleSymbols()
                                                    .filter(sym => Possessed.model.getScatterSymbols().some(s => s.reelID == sym.reelID && s.reelPosition == sym.reelPosition));
        
        scatters.forEach(sym => {
            tl.add(sym.playAdditionalSpinTrigger());
            tl.add(() => {
                Possessed.soundPlayer.playSound("spinsPlus");
            }, '<')
            tl.add(Possessed.reelView.reelCross.updateHotZones(Possessed.model.data.nextHotZoneSize));
            tl.add(() => {
                SlotGame.keypadPlugin.setZeroBetSpinCounter(Possessed.model.data.freespinsLeft)
            }, "<")
            tl.add(() => {
                Possessed.soundPlayer.playSound("spinsUp");
            }, '<')
            tl.add(()=>{}, ">0.5");
        })
    }
}